import { useEffect } from 'react';

// Slightly different to the legacy one. Works with a callback
export const useOnclickOutside = <T extends HTMLElement = HTMLElement>(
    element: T | null | undefined,
    handler: (event: MouseEvent | TouchEvent) => void,
    targetExcluded?: (target: Node) => boolean,
): void => {
    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent): void => {
            const target = event.target as Node;

            if (!element || element.contains(target) || targetExcluded?.(target)) {
                return;
            }

            handler(event);
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [element, handler, targetExcluded]);
};
